import { isPlatformBetaOperator } from '@/features/admin-beta/platformBetaAccess';
import { useAuthStore } from '@/store/auth.store';
/**
 * Navigation List Component
 * Renders the list of navigation items with dividers
 */

import React from 'react';
import { List, Divider } from '@mui/material';
import { NavItem } from './NavItem';
import { navItems, platformBetaNavItem, filterNavItemsByWorkspaceRole } from './navItems';
import { useCurrentWorkspaceRole } from '@/features/workspaces/hooks/useCurrentWorkspaceRole';

interface NavListProps {
  collapsed: boolean;
}

/**
 * Nav List Component
 * Renders all navigation items filtered by workspace role
 */
export const NavList: React.FC<NavListProps> = ({ collapsed }) => {
  const platformOperator = useAuthStore((s) => s.isAuthenticated && isPlatformBetaOperator(s.user));
  const workspaceRole = useCurrentWorkspaceRole();

  // Filter items based on workspace role
  const filteredItems = [
    ...filterNavItemsByWorkspaceRole(navItems, workspaceRole),
    ...(platformOperator ? [platformBetaNavItem] : []),
  ];

  return (
    <List>
      {filteredItems.map((item, index) => (
        <React.Fragment key={item.id}>
          {/* Divider before item if specified */}
          {item.divider && index > 0 && (
            <Divider component="li" role="presentation" aria-hidden="true" sx={{ my: 1 }} />
          )}

          {/* Navigation Item */}
          <NavItem item={item} collapsed={collapsed} />
        </React.Fragment>
      ))}
    </List>
  );
};
